import Markdown from 'react-markdown';
import remarkGfm from "remark-gfm";
import { cn } from "../../../lib/utils";
import { Block as BlockType } from "../../../types/document";

interface BlockContentProps {
  block: BlockType;
  dimmed?: boolean;
  stripListMarker?: boolean;
}

export const BlockContent = ({ block, dimmed = false, stripListMarker = false }: BlockContentProps) => {
  const maybeStripListMarker = (text: string): string => {
    if (!stripListMarker || !text) return text;
    const patterns = [/^\s*[-*+]\s+/, /^\s*\d+[.)]\s+/];
    for (const re of patterns) {
      if (re.test(text)) {
        return text.replace(re, "");
      }
    }
    return text;
  };

  const content = maybeStripListMarker(block.value);

  switch (block.type) {
    case "header1":
      return <h1 className={dimmed ? "text-gray-300!" : ""}>{block.value}</h1>;
    case "header2":
      return <h2 className={dimmed ? "text-gray-300!" : ""}>{block.value}</h2>;
    case "header3":
      return <h3 className={dimmed ? "text-gray-300!" : ""}>{block.value}</h3>;
    case "header4":
      return <h4 className={dimmed ? "text-gray-300!" : ""}>{block.value}</h4>;
    case "image":
      return (
        <div className="my-4">
          <img
            src={block.value ?? ""}
            alt="Block image"
            className={cn("max-w-full h-auto rounded-lg shadow-sm", dimmed && "opacity-30")}
          />
        </div>
      );
    case "text":
    case "markdown":
      return dimmed ? (
        <div className="prose prose-p:text-green! text-gray-300">
          <Markdown>{content}</Markdown>
        </div>
      ) : (
        <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
      );
    default:
      return <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
  }
};
